export enum WorkflowStarterType {
    /**
     * Selection methods screen (left side of the Runner),
     * where the user can upload a file, or select "My Files"
     */
    SelectionMethods = 'SelectionMethods',
    Web = 'web',
    FileExplorerApeerFiles = 'FileExplorerApeerFiles',
}
